export class User {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly email: string,
    public readonly country: string,
    public readonly roles: string[],
    public readonly avatar?: { id: string, url: string } | null,
  ) { }
}
